import { FC } from 'react';

import { Alert, AlertTitle } from '@mui/material';

import { CFN_PIECES_WARNING_BODY, CFN_PIECES_WARNING_TITLE } from '../../../utils/cfnPieces';

/**
 * Avertissement affiché au-dessus de chaque zone de fichiers d'une modale de
 * démarche (CTVO, DC, DA, DA deal, dépôt de pièces) : tout ce qui est listé
 * part au coffre-fort numérique légal, il faut retirer les pièces étrangères
 * au véhicule avant de soumettre (point sprint septembre 2026, François).
 */
const CfnPiecesWarning: FC<{ compact?: boolean }> = ({ compact = false }) => (
  <Alert severity="warning" sx={{ mb: 1, mt: compact ? 0 : 1 }}>
    <AlertTitle sx={{ fontWeight: 600, mb: compact ? 0 : 0.5 }}>{CFN_PIECES_WARNING_TITLE}</AlertTitle>
    {CFN_PIECES_WARNING_BODY}
  </Alert>
);

export default CfnPiecesWarning;
